import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  connect() {
    this.element.addEventListener('input', e => e.target.parentNode.dataset.replicatedValue = e.target.value)
  }
}
